import { render, staticRenderFns } from "./Realnameauth.vue?vue&type=template&id=33ef29f5&scoped=true"
import script from "./Realnameauth.vue?vue&type=script&lang=js"
export * from "./Realnameauth.vue?vue&type=script&lang=js"
import style0 from "./Realnameauth.vue?vue&type=style&index=0&id=33ef29f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ef29f5",
  null
  
)

export default component.exports